import { styled } from 'libs/ui/styled';

import { StackProps } from './types';

const Box = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'justifyContent' &&
    prop !== 'alignItems' &&
    prop !== 'spacing' &&
    prop !== 'alignSelf' &&
    prop !== 'flexWrap' &&
    prop !== 'flex',
})<StackProps>(
  ({
    spacing = 0,
    direction = 'column',
    alignItems,
    justifyContent,
    alignSelf,
    flexWrap,
    flex,
  }) => ({
    display: 'flex',
    flexDirection: direction,
    gap: spacing,
    alignItems,
    justifyContent,
    flexWrap,
    flex,
    alignSelf,
  })
);

export const Stack = styled(Box)({});
